import { getZrmListingInfo, getZrmRentalsLead, getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackListingEvent, trackUserEvent } from '../../analytics';
import {
  type ClickstreamEventParams,
  SEMANTIC_EVENT_NAME,
  TOPIC_TAG_TXT,
  TRIGGER_LOCATION,
  TRIGGER_OBJECT,
  TRIGGER_SOURCE,
  TRIGGER_TYPE,
} from './globals';
import type { ZrmClickstreamUserOrNull } from '../../analytics/types';

// https://dataportal.zillowgroup.net/event-registry/2423
export const CONVERSATION_ITEM_SELECT_EVENT_TYPE_ID = '2423';
export const emitConversationItemSelectEvent = (user: ZrmClickstreamUserOrNull) =>
  trackUserEvent({
    envelope: {
      event_type_id: CONVERSATION_ITEM_SELECT_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.IreneInbox,
      trigger_source_nm: TRIGGER_SOURCE.ConversationItem,
      trigger_object_nm: TRIGGER_OBJECT.LeadList,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ManageLead,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/8295
export const emitStoreMessageToLocalStorageEvent = ({ user, listing, triggerLocation, lead }: ClickstreamEventParams) =>
  trackListingEvent({
    envelope: {
      event_type_id: '8295',
      event_type_version_id: '3',
      event_template_id: '628',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: triggerLocation,
      trigger_source_nm: TRIGGER_SOURCE.ConversationItem,
      trigger_object_nm: TRIGGER_OBJECT.LeadList,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ManageLead,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
    ...getZrmListingInfo(listing),
    ...getZrmRentalsLead(lead),
  });
